(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name PacientesController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('PacientesController', PacientesController);

    PacientesController.$inject = ["GenerallabService","AnimalesService","$timeout","$location",'$anchorScroll'];

    function PacientesController(GenerallabService,AnimalesService,$timeout,$location,$anchorScroll)
    {

    	var vm = this;
        vm.animalesCentro = [];
        vm.generalLab = GenerallabService;
        vm.categoriasEspecies = [];
        vm.filtros = { page : 0 };
        vm.newAnimal = {};
        vm.newPaciente = false;

        vm.generalLab.optionsEspecies.ajax.data = function (params) {
            return {
              q: params.term, // search term
              page: params.page,
              lang_id: lang_id,
              categoriaespecie: vm.newAnimal.categoriaespecie_id,
              per_page: 20
            };
        };

        vm.nuevaFicha = function(res){
            vm.newPaciente = res;
        }

        vm.nextPagePacientes = function(){
            vm.filtros.page++;
        }

        vm.guardarpaciente = function(){
            vm.loadingGuardar = true;
            AnimalesService.guardarPaciente(vm.newAnimal,function(data){
                console.log(vm.newAnimal);
                AnimalesService.getAnimalesCentro({},vm.filtros,function(dataserv){
                    vm.animalesCentro = dataserv.animales;
                    $timeout(function(){
                        vm.loadingGuardar = false;
                        vm.codeGuardar = data.code;
                        if(data.code==1){
                            vm.newAnimal = {};
                            vm.newPaciente = false;
                        }
                    });
                });
                
                
            });
        }

        vm.getCategoriasEspecies = function(){
            AnimalesService.getCategoriasEspecies(function(data){
                vm.categoriasEspecies = data.categoriasEspecies;
            });
        }


    
        vm.generalLab.optionsRaces.ajax.data = function (params) {
            return {
              q: params.term, // search term
              page: params.page,
              lang_id: lang_id,
              especieseleccionada: vm.filtros.especie,
              per_page: 20
            };
        };

        vm.optionsRacesNew = angular.copy(vm.generalLab.optionsRaces);
        vm.optionsRacesNew.ajax.data = function (params) {
            return {
              q: params.term, // search term
              page: params.page,
              lang_id: lang_id,
              especieseleccionada: vm.newAnimal.especie_id,
              per_page: 20
            };
        };
        
    	vm.loading = true;
    	vm.init = function(page){
            vm.loading = true;
            console.log("page",page);
            if(typeof(page)!='undefined'){
                vm.filtros.page = page;
            }
    		AnimalesService.getAnimalesCentro({},vm.filtros,function(data){
                vm.loading = false;

                if(typeof(page)!='undefined'){

                    $timeout(function(){
                        $('.animaltable').scrollTop(0);
                        vm.animalesCentro = data.animales;
                    });
                }else{
                    vm.animalesCentro = vm.animalesCentro.concat(data.animales);
                }
            });
    	}
        vm.init(0);
               
    }


})();